const UserList = () =>
  import(
    /* webpackChunkName: "restrictions" */ '../../views/user/components/user-list/UserList.vue'
  )
const NewUser = () =>
  import(
    /* webpackChunkName: "restrictions" */ '../../views/user/components/new-user/NewUser.vue'
  )
const User = () =>
  import(/* webpackChunkName: "restrictions" */ '../../views/user/User.vue')

export default {
  path: 'user',
  component: User,
  meta: { authenticate: true },
  children: [
    {
      path: 'list',
      name: 'UserList',
      component: UserList,
      meta: {
        breadcrumb: [
          { name: 'Administração', pathName: '' },
          { name: 'Cadastro de Usuários', pathName: 'UserList' },
        ],
        actionButtons: [
          {
            type: 'nude-primary',
            text: 'CADASTRAR USUÁRIO',
            to: 'NewUser',
            tabTitle: 'CADASTRAR USUÁRIO',
          },
        ],
        claims: ['UserAdmin.All'],
      },
    },
    {
      path: 'new',
      name: 'NewUser',
      component: NewUser,
      meta: {
        breadcrumb: [
          { name: 'Administração', pathName: '' },
          { name: 'Cadastro de Usuários', pathName: 'UserList' },
          { name: 'Novo Usuário', pathName: 'NewUser' },
        ],
        claims: ['UserAdmin.All'],
      },
    },
  ],
}
